import {Injectable} from '@angular/core';
import {
    BarChartConfiguration,
    isBarChartConfiguration, isSeriesSummaryChartConfiguration, SeriesSummaryChartConfiguration,
    UnionChartConfiguration
} from "../charts/chart-config/chart-configuration";
import {
    PlotlyChartConfigTranslationService,
    PlotlyChartConfiguration,
    PlotlyDataConfiguration,
    PlotlyLayoutConfiguration,
    PlotlyConfigConfiguration
} from "./plotly-chart-config-translation.service";
import {SeriesSummaryChartTileConfiguration} from "../charts/chart-config/generic-chart-tile.configuration";

@Injectable({
    providedIn: 'root'
})
export class PlotlySummaryChartConfigTranslationService extends PlotlyChartConfigTranslationService {
    constructor() {
        super()
    }

    configureChart(config: SeriesSummaryChartConfiguration): Partial<PlotlyChartConfiguration> {
        let plotlyChart: PlotlyChartConfiguration = {
            data: this.configurePlotlyData(config),
            layout: this.configurePlotlyLayout(config),
            config: this.configurePlotlyConfig(config)
        }
        return plotlyChart;
    }

    configurePlotlyConfig(config: SeriesSummaryChartConfiguration): PlotlyConfigConfiguration {
        let options = super.configurePlotlyConfig(config);
        // Remove only lasso tool (logo is already removed by parent class)
        options.modeBarButtonsToRemove = ['lasso2d', 'select2d'];
        return options;
    }

    private configurePlotlyData(config: SeriesSummaryChartConfiguration): PlotlyDataConfiguration[] {
        let data = [];
        config.key_values.forEach(key => {
            const x = config.orientation === 'h' ? config.y_values[key] : config.x_values['series'];
            const y = config.orientation === 'h' ? config.x_values['series'] : config.y_values[key];
            let trace: Partial<PlotlyDataConfiguration> = this.configureBasePlotlyData(config, x, y, key);
            trace.name = config.names[key];
            trace.textfont = config.styles?.[key];
            trace.orientation = config.orientation;
            trace.textposition = "inside";
            trace.insidetextanchor = "middle";
            trace.width = 0.4;
            data.push(trace);
        })
        return data;
    }

    configurePlotlyLayout(config: UnionChartConfiguration): PlotlyLayoutConfiguration {
        let layout: PlotlyLayoutConfiguration = this.configureBasePlotlyLayout(config);
        if (isSeriesSummaryChartConfiguration(config)) {
            layout.barmode = config.barmode;
            layout.showlegend = true;
            layout.legend = {
                orientation: "h",
                x: 0.5,
                xanchor: 'center',
                traceorder: 'normal'
            }
            layout.xaxis.range = [config.y_min, config.y_max];
            // Add % suffix to x-axis labels and format to 1 decimal place
            layout.xaxis.ticksuffix = '%';
            layout.xaxis.tickformat = '.1f';
            // Increase bottom margin to prevent legend cutoff and allow automargin
            layout.margin = {
                t: 40,
                b: 80,
                l: 60,
                r: 20
            };
            layout.automargin = true;
        }
        if (config.today_line) {
            layout.shapes = (layout.shapes || []).concat(config.today_line);
            layout.annotations = (layout.annotations || []).concat(
                [
                // {
                //     x: config.today_line.x0,
                //     y: Number(config.today_line.y1) + 0.1,
                //     yref: 'paper',
                //     text: 'Today',
                //     showarrow: false,
                //     xanchor: 'center',
                //     font: {
                //         color: 'red',
                //         size: 12
                //     }
                // }
            ])
        }
        return layout;

    }
}
